import API from '@/shared/plugins/Api/API'

class SqlViews extends API {
  list (filter) {
    return this.request({
      method: 'GET',
      url: 'v4/sql_views',
      params: filter ? { filter: JSON.stringify(filter) } : undefined
    })
  }

  validate ({ database_id, sql_definition }) {
    return this.request({
      method: 'POST',
      url: 'v4/sql_views/validate',
      data: { database_id, sql_definition }
    })
  }

  create (payload) {
    return this.request({ method: 'POST', url: 'v4/sql_views', data: payload })
  }

  update (id, payload) {
    return this.request({ method: 'PUT', url: `v4/sql_views/${id}`, data: payload })
  }

  get (id, { resolve = false } = {}) {
    return this.request({
      method: 'GET',
      url: `v4/sql_views/${id}`,
      params: resolve ? { resolve: true } : undefined
    })
  }

  remove (id) {
    return this.request({ method: 'DELETE', url: `v4/sql_views/${id}` })
  }
}

export default SqlViews
